import React from 'react'
import PropTypes from 'prop-types'
import {reduxForm, Field} from 'redux-form'
import {Button, Tooltip, ClearIcon} from 'rambler-ui'
import {dateInvalid} from 'utils/validation'
import InlineForm from 'components/InlineForm'
import BirthdayField from 'components/BirthdayField'
import RowButton from 'components/RowButton'

function ChangeBirthday({submitting, buttonTooltip, onClose, handleSubmit}) {
  return (
    <InlineForm onSubmit={handleSubmit}>
      <Field
        component={BirthdayField}
        name="birthday"
        validate={dateInvalid}
        clearable
        autoFocus
      />
      <Tooltip
        position="bottom"
        content={buttonTooltip}
        isOpened={!!buttonTooltip}>
        <Button
          type="primary"
          buttonType="submit"
          tabIndex="0"
          loading={submitting}
          disabled={submitting}>
          Сохранить
        </Button>
      </Tooltip>
      <RowButton label="Закрыть" onClick={onClose}>
        <ClearIcon />
      </RowButton>
    </InlineForm>
  )
}

ChangeBirthday.propTypes = {
  submitting: PropTypes.bool,
  buttonTooltip: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired
}

export default reduxForm({form: 'changeBirthday'})(ChangeBirthday)
